const isMobileBrowser = () => navigator?.userAgent &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export default isMobileBrowser;
//# sourceMappingURL=isMobileBrowser.js.map